import postcard1 from "../../assets/images/postcard1.jpg";
import postcard2 from "../../assets/images/postcard2.jpg";
import postcard3 from "../../assets/images/postcard3.jpg";
import postcard4 from "../../assets/images/postcard4.jpg";
import postcard5 from "../../assets/images/postcard5.jpg";
import postcard6 from "../../assets/images/postcard6.jpg";
import postcard7 from "../../assets/images/postcard7.jpg";
import postcard8 from "../../assets/images/postcard8.jpg";
import postcard9 from "../../assets/images/postcard9.jpg";
import postcard10 from "../../assets/images/postcard10.jpg";
import postcard11 from "../../assets/images/postcard11.jpg";
import postcard12 from "../../assets/images/postcard12.jpg";

import postcard1thumb from "../../assets/images/postcard1thumb.jpg";
import postcard2thumb from "../../assets/images/postcard2thumb.jpg";
import postcard3thumb from "../../assets/images/postcard3thumb.jpg";
import postcard4thumb from "../../assets/images/postcard4thumb.jpg";
import postcard5thumb from "../../assets/images/postcard5thumb.jpg";
import postcard6thumb from "../../assets/images/postcard6thumb.jpg";
import postcard7thumb from "../../assets/images/postcard7thumb.jpg";
import postcard8thumb from "../../assets/images/postcard8thumb.jpg";
import postcard9thumb from "../../assets/images/postcard9thumb.jpg";
import postcard10thumb from "../../assets/images/postcard10thumb.jpg";
import postcard11thumb from "../../assets/images/postcard11thumb.jpg";
import postcard12thumb from "../../assets/images/postcard12thumb.jpg";

const presetPostcardFront = [
  {
    id: 1,
    src: postcard1,
    thumb: postcard1thumb,
    useText: 1,

    text1: "GREETINGS FROM ...",
    top1: 80,
    left1: 2,
    size1: 2.5,
    color1: "#ffffff",
    border1: 2,
    borderColor1: "#333333",
    alignText1: "center",
  },
  {
    id: 2,
    src: postcard2,
    thumb: postcard2thumb,
    useText: 1,

    text1: "GREETINGS FROM ...",
    top1: 80,
    left1: 2,
    size1: 2.5,
    color1: "#ffffff",
    border1: 2,
    borderColor1: "#333333",
    alignText1: "center",
  },
  {
    id: 3,
    src: postcard3,
    thumb: postcard3thumb,
    useText: 1,

    text1: "GREETINGS FROM ...",
    top1: 80,
    left1: 2,
    size1: 2.5,
    color1: "#ffffff",
    border1: 2,
    borderColor1: "#333333",
    alignText1: "center",
  },
  {
    id: 4,
    src: postcard4,
    thumb: postcard4thumb,
    useText: 1,

    text1: "GREETINGS FROM ...",
    top1: 80,
    left1: 2,
    size1: 2.5,
    color1: "#ffffff",
    border1: 2,
    borderColor1: "#333333",
    alignText1: "center",
  },
  {
    id: 5,
    src: postcard5,
    thumb: postcard5thumb,
    useText: 1,

    text1: "GREETINGS FROM ...",
    top1: 80,
    left1: 2,
    size1: 2.5,
    color1: "#ffffff",
    border1: 2,
    borderColor1: "#333333",
    alignText1: "center",
  },
  {
    id: 6,
    src: postcard6,
    thumb: postcard6thumb,
    useText: 1,

    text1: "GREETINGS FROM ...",
    top1: 80,
    left1: 2,
    size1: 2.5,
    color1: "#ffffff",
    border1: 2,
    borderColor1: "#333333",
    alignText1: "center",
  },
  {
    id: 7,
    src: postcard7,
    thumb: postcard7thumb,
    useText: 1,

    text1: "GREETINGS FROM ...",
    top1: 80,
    left1: 2,
    size1: 2.5,
    color1: "#ffffff",
    border1: 2,
    borderColor1: "#333333",
    alignText1: "center",
  },
  {
    id: 8,
    src: postcard8,
    thumb: postcard8thumb,
    useText: 1,

    text1: "GREETINGS FROM ...",
    top1: 80,
    left1: 2,
    size1: 2.5,
    color1: "#ffffff",
    border1: 2,
    borderColor1: "#333333",
    alignText1: "center",
  },
  {
    id: 9,
    src: postcard9,
    thumb: postcard9thumb,
    useText: 1,

    text1: "GREETINGS FROM ...",
    top1: 80,
    left1: 2,
    size1: 2.5,
    color1: "#ffffff",
    border1: 2,
    borderColor1: "#333333",
    alignText1: "center",
  },
  {
    id: 10,
    src: postcard10,
    thumb: postcard10thumb,
    useText: 1,

    text1: "GREETINGS FROM ...",
    top1: 80,
    left1: 2,
    size1: 2.5,
    color1: "#ffffff",
    border1: 2,
    borderColor1: "#333333",
    alignText1: "center",
  },
  {
    id: 11,
    src: postcard11,
    thumb: postcard11thumb,
    useText: 1,

    text1: "GREETINGS FROM ...",
    top1: 80,
    left1: 2,
    size1: 2.5,
    color1: "#ffffff",
    border1: 2,
    borderColor1: "#333333",
    alignText1: "center",
  },
  {
    id: 12,
    src: postcard12,
    thumb: postcard12thumb,
    useText: 1,

    text1: "GREETINGS FROM ...",
    top1: 80,
    left1: 2,
    size1: 2.5,
    color1: "#ffffff",
    border1: 2,
    borderColor1: "#333333",
    alignText1: "center",
  },
];
export default presetPostcardFront;
